import React from "react";
import PropTypes from "prop-types";

export function LoadMore({items, itemsViewed, handleClick}) {

    return (<>
            <div className="load-more-container">
                <ProgressIndicator
                    itemsViewed={itemsViewed}
                    items={items}
                />
                <LoadMoreButton onClick={(e) => {e.preventDefault(); handleClick()}} />
            </div>
            <style jsx>
                {`
                .load-more-container {
                    text-align: center;
                    margin-top: 3em;
                }
                `}
            </style>
    </>);
}

function ProgressIndicator({ itemsViewed, items }) {
    const contrastTextColor = '#393972';
    const progress = (itemsViewed / items) * 100;
    return (
        <div className="progress-indicator">
            <p>
                You've viewed{" "}
                <strong className="progress-indicator__number">
                    {itemsViewed}
                </strong>{" "}
                of{" "}
                <strong className="progress-indicator__number">
                    {items}
                </strong>{" "}
                items
            </p>
            <span className="progress-indicator__progress-container">
                <span
                    className="progress-indicator__progress"
                    style={{ width: `${progress}%` }}
                />
            </span>
            <style jsx>{`
                .progress-indicator__number {
                    color: ${contrastTextColor};
                }
                .progress-indicator__progress-container {
                    display: block;
                    margin: 1em auto 1.25em;
                    background-color: rgba(0, 0, 0, 0.1);
                    border-radius: 3px;
                    height: 6px;
                    width: 280px;
                }
                .progress-indicator__progress {
                    display: block;
                    background-color: ${contrastTextColor};
                    border-radius: 3px;
                    height: 100%;
                    width: 0;
                }
            `}</style>
        </div>
    );
}

function LoadMoreButton({ onClick }) {
    const baseFontSize = '1';
    const contrastTextColor ='#393972';
    const baseLineHeight = '1.5';

    return (
        <button
            className="load-more-button"
            onClick={onClick}
        >
            Load more
            <style jsx>{`
                .load-more-button {
                    font-size: ${baseFontSize}em;
                    font-weight: 600;
                    line-height: ${baseLineHeight};
                    padding: 0.5em 3em;
                    color: ${contrastTextColor};
                    border-radius: 10px;
                    border: 2px solid ${contrastTextColor};
                    cursor: pointer;
                }
                .load-more-button:hover {
                    background-color: ${contrastTextColor};
                    color: #fff;
                }
                .load-more-button:focus,
                .load-more-button:active {
                    outline: 0;
                    background-color: ${contrastTextColor};
                    color: #fff;
                }
            `}</style>
        </button>
    );
}

LoadMoreButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};
